module.exports = __webpack_public_path__ + "static/img/placeholder.c84137a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/placeholder.jpg
// module id = IgEX
// module chunks = 15